<template>
    <div class="menu user_info_border">
        <div class="dropdown_list_header">
            <div class="avatar_label_group">
                <div class="text_and_supporting_text">
                    <div class="text">{{ user.first_name }} {{ user.last_name }} </div>
                    <div class="supporting-text">{{ user.username }}</div>
                    <div v-if="user.role" class="role-text">{{ roleLabel(user.role) }}</div>
                </div>
            </div>
        </div>
        <div class="menu-items">
            <div class="dropdown-list-item" v-if="user.is_superuser">
                <div class="content">
                    <div class="icon-and-text" @click="modalUsersManager">
                        <Avatar class="user-01-icon" />
                        <div class="text1">Gestión de Usuarios</div>
                    </div>
                </div>
            </div>
            <div class="dropdown-list-item1">
                <img class="divider-icon" alt="" src="Divider.svg">
            </div>
            <div class="dropdown-list-item">
                <div class="content">
                    <div class="icon-and-text" @click="logout">
                        <Logout class="user-01-icon" />
                        <div class="text1">Cerrar sesión</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import UsersManager from "@/components/modals/UsersManager";
import Avatar from "@/components/svg/Avatar.vue";
import Logout from "@/components/svg/Logout.vue";
import { roleLabel } from "@/utils/roles";
import { mapActions } from "vuex";

export default {
    name: "UserMenu",
    components: {
        Avatar,
        Logout,
    },
    props: {
        user: Object,
    },
    methods: {
        roleLabel,
        ...mapActions("userAuth", [
            "clearUserInfo",
            "setLoginInfo",
            "deleteSelf",
            "getUserInfo",
        ]),
        modalUsersManager() {
            this.$buefy.modal.open({
                ...this.modalDefault,
                component: UsersManager,
            });
        },
        async logout() {
            // El store ya no navega; el caller redirige tras limpiar la sesión.
            try {
                await this.clearUserInfo();
            } finally {
                this.$router.push("/").catch(() => {});
            }
        },
    },
};
</script>
<style scoped>
.text {
    align-self: stretch;
    position: relative;
    line-height: 20px;
    font-weight: 600;
}

.supporting-text {
    align-self: stretch;
    position: relative;
    line-height: 20px;
    color: #475467;
    word-wrap: break-word;
    word-break: break-all;
    overflow-wrap: break-word;
    white-space: normal;
}

.role-text {
    align-self: stretch;
    position: relative;
    margin-top: 2px;
    line-height: 18px;
    font-size: 12px;
    font-weight: 500;
    color: #0d5154;
}


.user-01-icon {
    width: 16px;
    position: relative;
    height: 16px;
    overflow: hidden;
    flex-shrink: 0;
}

.text1 {
    flex: 1;
    position: relative;
    line-height: 20px;
    font-weight: 500;
}

.icon-and-text {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;
}

.content {
    flex: 1;
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 9px 10px;
}

.dropdown-list-item {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 1px 6px;
}

.divider-icon {
    flex: 1;
    position: relative;
    max-width: 100%;
    overflow: hidden;
    height: 1px;
}

.dropdown-list-item1 {
    width: 240px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 4px 0px;
    box-sizing: border-box;
}

.menu-items {
    align-self: stretch;
    background-color: #fff;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 4px 0px;
}

.menu {
    position: relative;
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid #eaecf0;
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    font-size: 14px;
    color: #344054;
    font-family: Inter;
}

.avatar_icon {
    width: 100%;
    position: relative;
    border-radius: 200px;
    height: 24px;
    z-index: 2;
}

.user_info_border {
    border: 1px solid #EAECF0;
    border-radius: 10px;
}

.dropdown_list_header {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 12px 16px;
}

.avatar_label_group {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
}

.text_and_supporting_text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    flex: 1;
}

.extra_margin {
    margin-right: 200px;
}
</style>
